import React from 'react';
import PropTypes from 'prop-types';

function PromotionText({ type, flagText, headline, content }) {
    return (
        <div className={`catalog-promotions__promotion-type catalog-promotions__promotion-type--${type} promotion-type`}>
            <div className="promotion-type__type-flag">{flagText}</div>
            <div className="promotion-type__description">
                <div className="promotion-type__emphasized">{headline}</div>
                {content}
            </div>
        </div>
    );
}

PromotionText.propTypes = {
    type: PropTypes.string.isRequired,
    flagText: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
};

export { PromotionText };
